/**
 * Shows current session information
 */

import Modal from "/WebInterface/new-ui/modules/modal.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import { ajax } from "/WebInterface/new-ui/assets/js/utils/ajax.js";

let proxy = "/WebInterface/";
proxy = proxy.substring(0, proxy.length - ("/Web" + "Interface/").length);
const apiURL = "/WebInterface/function/";

export default class SessionChecker {
  constructor({
    dataStorageKey = "sessionSeconds",
    startingPointVal = "-1",
    localTimerPeriod = 1000,
    sessionTimerPeriod = 10000,
    apiCommand = "getSessionTimeout",
    requestType = "GET",
    hashListener = {},
    update = function () {},
    events = function () {},
  }) {
    this.dataStorageKey = dataStorageKey;
    this.startingPointVal = startingPointVal;
    this.localTimerPeriod = localTimerPeriod;
    this.sessionTimerPeriod = sessionTimerPeriod;
    this.apiURL = apiURL;
    this.apiCommand = apiCommand;
    this.requestType = requestType;
    this.update = update;
    this.events = events;
    this.hashListener = hashListener;
    const base = this;
    this.inactivityLogoutModal = new Modal({
      title: "autoLogoutTitle",
      body: `<p data-i18n-key="autoLogoutText">You are about to log out due to inactivity</p>`,
      show: false,
      destroyOnClose: false,
      closable: false,
      uniqueId: "UI_AutoLogout",
      extraClasses: ["auto-logout-dialog"],
      minWidth: "300px",
      minHeight: "175px",
      buttons: [
        {
          label: "stayLoggedIn",
          close: true,
          classes: ["primary-button", "mr-3"],
          onClick: function () {
            base.makeReviveCall();
            base.logoutConfirmDialogShownRecently = true;
            setTimeout(function () {
              base.logoutConfirmDialogShownRecently = false;
            }, 10000);
          },
        },
        {
          label: "ignore",
          close: true,
          classes: ["is-link", "mr-3", "is-light"],
          onClick: function () {
            base.logoutConfirmDialogShownRecently = true;
          },
        },
      ],
    });
  }

  updateTimer = (external) => {
    const base = this;
    if (!external) {
      if (base.updateTimerID) clearTimeout(base.updateTimerID);
      base.updateTimerID = setTimeout(function () {
        base.updateTimer();
      }, base.localTimerPeriod);
    }
    const showLoggedout = () => {
      base.events("redirectOnLogout");
      if (base.updateTimerID) clearTimeout(base.updateTimerID);
      base.inactivityLogoutModal.show();
      base.inactivityLogoutModal.update({
        body: `<p data-i18n-key="loggedOutDueToInactivity">You are logged out due to inactivity. Please login to continue.</p>`,
        hasCloseOption: false,
        buttons: [
          {
            label: "login",
            close: true,
            classes: ["primary-button", "mr-3"],
            onClick: function () {
              base.events("loggedout");
            },
          },
        ],
      });
    };
    if (utils.cache.get(base.dataStorageKey) * 1 > 0) {
      var s = utils.cache.get(base.dataStorageKey) + ".0";
      base.update(
        t(
          "sessionTimeoutCountdown",
          { time: utils.formatTime({ secs: s }) },
          "(Session timeout in {time}.)"
        )
      );
      utils.cache.set(
        base.dataStorageKey,
        utils.cache.get(base.dataStorageKey) * 1 - 1
      );
    }
    var sessionSeconds = utils.cache.get("sessionSeconds") * 1 || 0;
    if (sessionSeconds <= 60 && sessionSeconds > 0) {
      //TODO: Handle striked out
      // if (base.$el.hasClass("strike-out")) {
      //   base.bindUserInfo(function (response) {
      //     if (response) {
      //       base.updateSessionSeconds(true);
      //     }
      //   });
      //   return false;
      // }
      if (!base.apiInProgress) {
        base.alertLogoutConfirmation(function () {
          base.apiInProgress = true;
          base.bindUserInfo(function (response) {
            if (!response) {
              base.apiInProgress = false;
            } else {
              base.updateSessionSeconds(true);
            }
          });
        });
      }
    } else if (sessionSeconds <= 0) {
      base.updateSessionSeconds(true, function (s, err) {
        if (err || s <= 0) {
          showLoggedout();
        } else if (s > 65) {
          base.inactivityLogoutModal.visible() &&
            base.inactivityLogoutModal.hide();
        }
      });
    }
  };

  updateSessionSeconds = (external, callBack) => {
    const base = this;
    if (base.getTimeoutInProgress) return;
    base.getTimeoutInProgress = true;
    ajax
      .call({
        data: {
          command: base.apiCommand,
        },
      })
      .then((resp) => {
        const xml = new DOMParser().parseFromString(resp, "text/xml");
        const result = utils.xmlToJson(xml);
        base.apiInProgress = false;
        base.ajaxCallRunning = false;
        const response =
          result && result.commandResult && result.commandResult.response;
        utils.cache.set(base.dataStorageKey, response);
        const remainingSecs = parseInt(response);
        if (remainingSecs > 65) {
          base.inactivityLogoutModal.visible() &&
            base.inactivityLogoutModal.hide();
        }
        //TODO: Show message received from server
        // if (msg) {
        //   msg = decodeURIComponent(msg);
        //   if (window.crushFTPTools && window.crushFTPTools.textEncode) {
        //     msg = crushFTPTools
        //       .textEncode(msg)
        //       .replace(/\n/g, "<br>")
        //       .replace(/ /g, "&nbsp;");
        //   }
        //   if (
        //     window.crushFTP &&
        //     window.crushFTP.UI &&
        //     window.crushFTP.UI.growl
        //   ) {
        //     crushFTP.UI.growl("Message", DOMPurify.sanitize(msg), false, false);
        //   } else if (window.growl) {
        //     window.growl("Message", msg, false);
        //   }
        // }
        base.initComplete = true;
        if (callBack) callBack(remainingSecs);
        // }
      })
      .fail((err) => {
        if (callBack) callBack(0, err);
      })
      .always(() => {
        base.getTimeoutInProgress = false;
        // if (!external) {
        if (base.updateSessionSecondsID)
          clearTimeout(base.updateSessionSecondsID);
        base.updateSessionSecondsID = setTimeout(function () {
          base.updateSessionSeconds();
        }, base.sessionTimerPeriod);
      });
  };

  makeReviveCall = () => {
    const base = this;
    const obj = {
      command: "getXMLListing",
      format: "JSONOBJ",
      path: "/",
      random: Math.random(),
    };
    ajax.call({
      data: obj,
      timeout: 10000000,
    });
  };

  alertLogoutConfirmation = (callBack) => {
    const base = this;
    if (base.keepUserSessionAlive) {
      base.makeReviveCall();
      callBack();
      return;
    }
    if (!callBack) return;
    if (
      base.inactivityLogoutModal.visible() ||
      base.logoutConfirmDialogShownRecently
    ) {
      return;
    } else {
      this.inactivityLogoutModal.show();
    }
  };
}
